/* eslint-disable max-len */
import React from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import './style.scss'

export default function SalesBox({
  totalAllOrder = 0,
  adminCostAllOrder = 0,
  paymentCollected = 0,
  totalPriceAfterDiscount = 0,
  eventCost,
  totalProfit,
  showProfit,
  hitpayFeeAllOrder = 0,
  onExit,
}) {
  const history = useHistory()
  const shouldShowAdminFee =
    Number.isFinite(Number(adminCostAllOrder)) && Number(adminCostAllOrder) !== 0

  const numericHitpayFee = Number(hitpayFeeAllOrder) || 0
  const shouldShowHitpayFee = numericHitpayFee > 0

  const handleBackEventList = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault()
    }
    if (onExit) {
      onExit()
    } else {
      history.push('/event/list-my-events')
    }
  }

  const hasDiscount =
    totalPriceAfterDiscount !== 0 &&
    totalPriceAfterDiscount !== undefined &&
    totalPriceAfterDiscount !== null
  const discountedTotal = totalAllOrder - totalPriceAfterDiscount
  const effectiveTotalPurchase = hasDiscount ? discountedTotal : totalAllOrder

  const numericEventCost = Number(eventCost) || 0
  const computedProfit =
    totalProfit !== undefined && totalProfit !== null
      ? Number(totalProfit) - numericHitpayFee
      : effectiveTotalPurchase - numericEventCost - numericHitpayFee

  const isNegativeProfit = computedProfit < 0
  const formattedProfit = isNegativeProfit
    ? `-$${Math.abs(computedProfit).toFixed(2)}`
    : `$${computedProfit.toFixed(2)}`

  const profitColor = isNegativeProfit
    ? 'var(--red-dark, #A32D2D)'
    : 'var(--teal-dark, #007A77)'

  const isProfitVisible =
    showProfit !== undefined
      ? Boolean(showProfit)
      : eventCost !== undefined && eventCost !== null && eventCost !== ''

  return (
    <React.Fragment>
      <div className="od-totals">
        <div>
          Total Purchase:{' '}
          <strong id="od-total-purchase">
            {hasDiscount ? (
              <>
                <span
                  className="text-decoration-line-through"
                  style={{ color: '#b8bbbe', marginRight: '4px' }}
                >
                  ${totalAllOrder?.toFixed(2)}
                </span>
                <span id="totalAmount">${discountedTotal?.toFixed(2)}</span>
              </>
            ) : (
              <>
                $<span id="totalAmount">{totalAllOrder?.toFixed(2)}</span>
              </>
            )}
          </strong>
        </div>

        {shouldShowAdminFee && (
          <div>
            Admin Fee:{' '}
            <strong>
              $<span id="adminCost">{adminCostAllOrder?.toFixed(2)}</span>
            </strong>
          </div>
        )}

        {shouldShowHitpayFee && (
          <div>
            Platform Fee:{' '}
            <strong id="od-platform-fee">
              $<span id="hitpayCommissionAmount">{numericHitpayFee?.toFixed(2)}</span>
            </strong>
          </div>
        )}

        <div>
          Payment Collected:{' '}
          <strong id="od-total-collected">
            $<span id="totalConfirmedPaid">{paymentCollected?.toFixed(2)}</span>
          </strong>
        </div>

        {isProfitVisible && (
          <div id="od-profit-row">
            Total Profit:{' '}
            <strong id="od-total-profit" style={{ color: profitColor }}>
              {formattedProfit}
            </strong>
          </div>
        )}
      </div>

      <button type="button" className="od-exit-btn" onClick={handleBackEventList}>
        Exit
      </button>
    </React.Fragment>
  )
}

SalesBox.propTypes = {
  totalAllOrder: PropTypes.number,
  adminCostAllOrder: PropTypes.number,
  paymentCollected: PropTypes.number,
  totalPriceAfterDiscount: PropTypes.number,
  eventCost: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  totalProfit: PropTypes.number,
  showProfit: PropTypes.bool,
  hitpayFeeAllOrder: PropTypes.number,
  onExit: PropTypes.func,
}
